// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".539.0.0." + {"1367": "a55d932a1f904bc5","2257": "e2ee79a5a90d4e19","2973": "3b9d9a08327cfe42","582": "21ebcd577770af59","7530": "6a25160fddcbc55d","7581": "8b85176ee3e2343b","8692": "741c9db4858b6258",}[chunkId] + ".css"
}